import React from 'react';
import connect from 'react-redux/lib/connect/connect';
import { AddOneBet, RemoveOneBet } from '../../common/actions/betAction';
import { checkMarket, fixedNumber, getMarketDetail, isEmpty, toastr } from '../../common/cores';
import BetItem from './BetItem';

const MarketItem = (props) => {

    const { betItemList, originSportslist, market, active, hideTitle, markettitle, eventParttitle, market_setting, kind_Id, interiorShowMarket } = props;
    let marketNametitleFlag = !isEmpty(market_setting) ? market_setting.market_name_setting : "0"
    const { bettedItems } = props;

    const checkBetted = (bet) => {
        // console.log(bettedItems.findIndex(item => item.betId === bet.Id) >= 0)
        return bettedItems.findIndex(item => item.betId === bet.Id) >= 0;
    }

    const onBetItem = (bet, betList, index) => {
        const Fixture = originSportslist.Fixture;
        if (bet.Price[0].Price === "-") {
            return;
        }
        if (!checkBetted(bet)) {
            const result = props.AddOneBet({ index, market, Fixture, bet, betList });
            if (!result) {
                return;//toastr.warning('배팅규정에 어긋납니다.');
            }
        }
        else
            props.RemoveOneBet(bet.Id);

    }

    return ((checkMarket(market, kind_Id) && !isEmpty(betItemList))) && (
        <div className={`sport_more_list_wrap ${!interiorShowMarket && "sport_more_list_anim_none"}`}>
            {(
                marketNametitleFlag !== "1" ?
                    <div className={`sport_more_title sport_more_list_anim ${!interiorShowMarket && "sport_more_list_anim_none"}`}>{markettitle}&nbsp;&nbsp;{eventParttitle}</div>
                    :
                    <div className={`sport_more_title sport_more_list_anim ${!interiorShowMarket && "sport_more_list_anim_none"}`}>[{eventParttitle}]&nbsp;&nbsp;{markettitle}</div>

            )}
            {
                betItemList.map((betList, index) => {
                    // console.log(!betList.data)
                    // console.log(betList) 
                    return (
                        <div className={`sport_more_list sport_more_list_anim ${!interiorShowMarket && "sport_more_list_anim_none"}`}
                            key={index}>
                            <ul>
                                {
                                    betList.data.map((item, itemIndex) => {
                                        // console.log(item);
                                        return (<BetItem
                                            key={market.MarketID + " " + index + " " + itemIndex}
                                            item={item}
                                            itemIndex={itemIndex}
                                            betList={betList}
                                            originSportslist={originSportslist}
                                            onBetItem={onBetItem}
                                            checkBetted={checkBetted}
                                            interiorShowMarket={interiorShowMarket}
                                             />);
                                    })
                                }
                            </ul>
                        </div>
                    )
                })
            }
        </div>
    );
};

const mapStateToProps = state => ({
    bettedItems: state.bet.bettedItems,
    market_setting: state.sports.market_setting
})

export default connect( mapStateToProps, { AddOneBet, RemoveOneBet })(MarketItem);



// WEBPACK FOOTER //
// ./src/components/sports/MarketItem.js